import { isVideoType } from '../videoPlayerTypes';
const isIdParts = (s) => [2, 3].includes(s.length) && isVideoType(s[1]);
// Split ExternalId string into its constituent parts. Throws exceptions if the
// id is invalid.
//
// Valid ids should be in the form:
//     "<media id>:<'video'|'playlist'>:<autoplay>"
const splitId = (externalId) => {
    if (externalId == null)
        throw new Error('tmlExternalId required');
    const parts = externalId.split(':');
    if (!isIdParts(parts))
        throw new TypeError('invalid AEPlayer tmlExternalId');
    if (parts[1] === 'playlist') {
        throw new Error('A+E Player playlist has been deprecated');
    }
    return parts;
};
// Decode the AE Player tml-external-id. Throws exceptions if the id is invalid.
//
// We're accepting an optional argument to maintain compatibility with old code.
export const decodeTmlExternalId = (externalId) => {
    const [mediaId, type, hasAutoplay] = splitId(externalId);
    return {
        mediaId,
        type,
        autoPlay: hasAutoplay?.toLowerCase() === 'autoplay',
    };
};
// Validate a ContentVideo or throw an exception.
const validateContentVideo = (contentVideo) => {
    if (contentVideo == null)
        throw new Error('contentVideo required');
    if (!['aeplayer', 'aeplayerPlaylist'].includes(contentVideo.videoPlatformCode)) {
        throw new Error('not an A+E Player ContentVideo: ' + contentVideo.videoPlatformCode);
    }
    if (contentVideo.videoPlatformCode === 'aeplayerPlaylist') {
        throw new Error('A+E Player playlist has been deprecated');
    }
};
// Gather the AE Player video parameters from a contentVideo.
export const getVideoParameters = (contentVideo) => {
    validateContentVideo(contentVideo);
    return {
        mediaId: contentVideo.videoPlatformId,
        type: contentVideo.videoPlatformCode === 'aeplayer' ? 'video' : 'playlist',
        // default. Potentially overridden by site.config.video.autoPlay
        autoPlay: false,
    };
};
// Gather the AE Player video URL from a VideoConfig and VideoParameters.
const parametersToUrl = (videoConfig, parts) => {
    const autoplay = parts.autoPlay ? 'true' : 'false';
    let url = videoConfig.aeplayer.playerUrl ?? '';
    if (videoConfig.aeplayer.playerUrl?.match(/\.html$/)) {
        const queryStrParam = parts.type === 'playlist' ? 'plid' : 'tpid';
        url += `?${queryStrParam}=${parts.mediaId}&autoplay=${autoplay}`;
    }
    else {
        url += `${parts.mediaId}?autoplay=${autoplay}`;
    }
    return url;
};
// Return the AE Player video URL given the 2-part tml-external-id. Throws
// exceptions if parameters are invalid.
export const tmlExternalIdToUrl = (videoConfig, externalId) => parametersToUrl(videoConfig, decodeTmlExternalId(externalId));
// Return the AE Player video URL from a contentVideo. Throws exceptions if
// parameters are invalid.
export const contentVideoToUrl = (videoConfig, contentVideo) => {
    const parts = getVideoParameters(contentVideo);
    // Site config for video should dictate the auto play behavior for any
    // ContentVideo object.
    parts.autoPlay = videoConfig.autoPlay ?? false;
    return parametersToUrl(videoConfig, parts);
};
//# sourceMappingURL=index.js.map